import {Component, ElementRef, inject, ChangeDetectionStrategy} from "@angular/core"
import {BdApiWebcomponent} from "@app/common/components/viewers/configurator/extensions/bd-cloud/types"
import {BdApiExtension as BdCloudApiExtension} from "@app/common/components/viewers/configurator/extensions/bd-cloud/bd-cloud"
import {ExtensionContext} from "@app/common/components/viewers/configurator/extensions/configurator-api-extension"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "bd-api",
    standalone: true,
    template: "",
    imports: [],
})
export class BdCloudApiComponent {
    private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef)

    private bdCloudApi = new BdCloudApiExtension()

    constructor() {
        customElements.whenDefined("cm-configurator-main").then(() => {
            const configurator = document.querySelector("cm-configurator-main") as unknown as {
                getExtensionContext(): ExtensionContext
                setAllowSelect: (allow: boolean) => void
            }
            this.bdCloudApi.setExtensionContext(configurator.getExtensionContext())
            configurator.setAllowSelect(true)
        })
    }

    bindWebcomponentApi() {
        const nativeElement = this.elementRef.nativeElement as BdApiWebcomponent
        nativeElement.bdApi = this.bdCloudApi
    }

    ngAfterViewInit(): void {
        this.bindWebcomponentApi()
    }
}
